import type { VerificationStatus } from '@hotjar/webapp/domains/activation/tracking-code/types';
import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';

import type { TrackingSite } from './utils';
import { extractSiteGroupingProps } from './utils';

export const trackingCodeVerificationAttempt = (
  site: TrackingSite,
  status: VerificationStatus,
): void => {
  if (typeof site !== 'undefined') {
    const data = { status, ...extractSiteGroupingProps(site) };
    Segment.track('Tracking Code Verification Attempted', data);
  }
};
